/**
 * This wrapper component detects when it's children throw an error and
 * prevents the error from crashing the page altogether. Instead, this
 * component will display a user friendly error message in their language
 */

import { Component, ErrorInfo, ReactNode } from 'react';
import swmc from '../assets/swmc.png';

export interface Props {
  debug?: string;
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true,
    };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const sendError = async (message, subject) => {
      if (window.location.hostname === 'localhost') return;
      // const payload = {
      //   url: 'email/error',
      //   method: 'post',
      //   data: {
      //     message,
      //     subject
      //   },
      // };
      try {
        // update payload url to ensure this email is sent as expected
        // await axiosCall(payload);
      } catch (err: any) {
        console.error('Could not send report', err);
        error = err?.response?.data?.message;
      }
    };

    const localStorageItems = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i); // Get the key at index i
      const value = localStorage.getItem(key); // Get the value associated with the key
      localStorageItems[key] = value; // Store the key-value pair in the object
    }

    const message = `
Debug: ${(this.props.debug || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')};<br/><br/>
LocalStorage: ${JSON.stringify(localStorageItems).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')};<br/><br/>
${error.stack}`;
    const subject = `Something went wrong! ${error.message}`;
    sendError(message, subject);
    console.error(this.props.debug, '\n\n', error.stack);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <section className='error-boundary'>
          <span aria-hidden='true'>
            <img alt='Something went wrong!' src={swmc} />
          </span>
          <article>
            <p role='alert'>
              <span className='sr-only'>Error: </span>Something went wrong!
            </p>
          </article>
        </section>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
